import { OptionProps } from 'types'

/**
 * Splits a search query into lowercased, whitespace-separated tokens.
 * A blank or whitespace-only query yields no tokens.
 */
export const searchTokens = (query: string): string[] => query.toLowerCase().trim().split(/\s+/).filter(Boolean)

/**
 * Order-independent option search (issue #10759): every word typed must appear as a
 * case-insensitive substring of the option's label or group, in any order. So "150 tray"
 * matches "Tray MD 150mm", while "150 bracket" matches nothing.
 *
 * Deliberately a plain substring test per token rather than a regex built from user input —
 * no escaping/injection concerns and no backtracking cost on large option lists.
 */
export const matchesAllTokens = (option: OptionProps, query: string): boolean => {
  const tokens = searchTokens(query)
  if (tokens.length === 0) return true

  const label = option.label ? option.label.toLowerCase() : ''
  const group = option.group ? option.group.toLowerCase() : ''

  return tokens.every((token) => label.includes(token) || group.includes(token))
}
